export const Data = [
  {
    type: "zh",
    videoUrl:"",
    videoUrl2:"https://www.victrum.com/image/nr/jjfa/11.mp4",
    numList : [
      {
        num : "1",
        tital : "美学修复",
        path: "mxxf"
      },
      {
        num : "2",
        tital : "外科种植",
        path: "ytys"
      },
      {
        num : "3",
        tital : "牙体牙髓",
        path: "zz"
      },
      {
        num : "4",
        tital : "牙周疾病",
        path: "zz"
      },
      {
        num : "5",
        tital : "正畸儿牙",
        path: "zz"
      },
    ],
    imgBoxUrl:"https://www.victrum.com/image/tp/临床应用banner.png",
    allData: [
      {
        num:"1",
        showdata:false,
        newDate: [
          {
            index: "mx1",
            imgUrl: "https://www.victrum.com/image/sprk/美学修复/拆除固定桥.png",
            text1: "铒激光在拆除固定桥的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在拆除固定桥的临床应用",
            text4: "查看详情",
          },
          {
            index: "mx2",
            imgUrl: "https://www.victrum.com/image/sprk/美学修复/拆除牙冠.png",
            text1: "铒激光在拆除牙冠的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在拆除牙冠的临床应用",
            text4: "查看详情",
          },
          {
            index: "mx3",
            imgUrl: "https://www.victrum.com/image/sprk/美学修复/牙龈脱色.png",
            text1: "铒激光在牙龈脱色治疗中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在牙龈脱色治疗中的临床应用",
            text4: "查看详情",
          },
          {
            index: "mx4",
            imgUrl: "https://www.victrum.com/image/sprk/美学修复/拆除瓷贴面.png",
            text1: "铒激光在去除瓷贴面的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在去除瓷贴面的临床应用",
            text4: "查看详情",
          },
          {
            index: "mx5",
            imgUrl: "https://www.victrum.com/image/sprk/美学修复/激光取冠.png",
            text1: "铒激光在取冠的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在取冠的临床应用",
            text4: "查看详情",
          }
        ]
      },
      {
        num:"2",
        showdata:false,
        newDate: [
          {
            index: "wk1",
            imgUrl: "https://www.victrum.com/image/sprk/外科种植/种植二期.png",
            text1: "铒激光在种植二期手术中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在种植二期手术中的临床应用",
            text4: "查看详情",
          },
          {
            index: "wk2",
            imgUrl: "https://www.victrum.com/image/sprk/外科种植/种植体周围炎.png",
            text1: "铒激光在种植体周围炎的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在种植体周围炎的临床应用",
            text4: "查看详情",
          },
          {
            index: "wk3",
            imgUrl: "https://www.victrum.com/image/sprk/外科种植/种植二期手术-1.png",
            text1: "铒激光在种植二期手术中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在种植二期手术中的临床应用",
            text4: "查看详情",
          },
          {
            index: "wk4",
            imgUrl: "https://www.victrum.com/image/sprk/外科种植/种植体二期手术.png",
            text1: "铒激光在种植体二期手术中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在种植体二期手术中的临床应用",
            text4: "查看详情",
          },
          {
            index: "wk5",
            imgUrl: "https://www.victrum.com/image/sprk/外科种植/种植二期手术.png",
            text1: "铒激光在种植二期手术中的应用",
            text2: "2026年03月31日",
            text3: "铒激光在种植二期手术中的应用",
            text4: "查看详情",
          }
        ]
      },
      {
        num:"3",
        showdata:false,
        newDate: [
          {
            index: "yt1",
            imgUrl: "https://www.victrum.com/image/sprk/牙体牙髓/24窝沟龋.png",
            text1: "铒激光在24窝沟龋治疗中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在24窝沟龋治疗中的临床应用",
            text4: "查看详情",
          },
          {
            index: "yt2",
            imgUrl: "https://www.victrum.com/image/sprk/牙体牙髓/根管荡洗.png",
            text1: "铒激光在根管荡洗中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在根管荡洗中的临床应用",
            text4: "查看详情",
          },
          {
            index: "yt3",
            imgUrl: "https://www.victrum.com/image/sprk/牙体牙髓/活髓切断.png",
            text1: "铒激光在活髓切断中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在活髓切断中的临床应用",
            text4: "查看详情",
          },
          {
            index: "yt4",
            imgUrl: "https://www.victrum.com/image/sprk/牙体牙髓/楔状缺损激光去腐.png",
            text1: "铒激光在楔状缺损去腐中的应用",
            text2: "2026年03月31日",
            text3: "铒激光在楔状缺损去腐中的应用",
            text4: "查看详情",
          },
          {
            index: "yt5",
            imgUrl: "https://www.victrum.com/image/sprk/牙体牙髓/牙本质脱敏.png",
            text1: "铒激光在牙本质脱敏中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在牙本质脱敏中的临床应用",
            text4: "查看详情",
          }
        ]
      },
      {
        num:"4",
        showdata:false,
        newDate: [
          {
            index: "yz1",
            imgUrl: "https://www.victrum.com/image/sprk/牙周疾病/重度牙周炎.png",
            text1: "铒激光在重度牙周炎治疗中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在重度牙周炎治疗中的临床应用",
            text4: "查看详情",
          },
          {
            index: "yz2",
            imgUrl: "https://www.victrum.com/image/sprk/牙周疾病/切除牙龈瘤.png",
            text1: "铒激光在切除牙龈瘤治疗中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在切除牙龈瘤治疗中的临床应用",
            text4: "查看详情",
          },
          {
            index: "yz3",
            imgUrl: "https://www.victrum.com/image/sprk/牙周疾病/阿弗他溃疡.png",
            text1: "铒激光在治疗阿弗他溃疡中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在治疗阿弗他溃疡中的临床应用",
            text4: "查看详情",
          },
          {
            index: "yz4",
            imgUrl: "https://www.victrum.com/image/sprk/牙周疾病/激光切龈.png",
            text1: "铒激光在切龈治疗中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在切龈治疗中的临床应用",
            text4: "查看详情",
          },
          {
            index: "yz5",
            imgUrl: "https://www.victrum.com/image/sprk/牙周疾病/牙周袋清创.png",
            text1: "铒激光在牙周袋清创中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在牙周袋清创中的临床应用",
            text4: "查看详情",
          }
        ]
      },
      {
        num:"5",
        showdata:false,
        newDate: [
          {
            index: "zq1",
            imgUrl: "https://www.victrum.com/image/sprk/正畸儿牙/导萌术.png",
            text1: "铒激光在导萌术中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在导萌术中的临床应用",
            text4: "查看详情",
          },
          {
            index: "zq2",
            imgUrl: "https://www.victrum.com/image/sprk/正畸儿牙/龋齿治疗.png",
            text1: "铒激光在龋齿治疗中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在龋齿治疗中的临床应用",
            text4: "查看详情",
          },
          {
            index: "zq3",
            imgUrl: "https://www.victrum.com/image/sprk/正畸儿牙/去龋.png",
            text1: "铒激光在去龋中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在去龋中的临床应用",
            text4: "查看详情",
          },
          {
            index: "zq4",
            imgUrl: "https://www.victrum.com/image/sprk/正畸儿牙/激光助萌.png",
            text1: "铒激光在助萌术中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在助萌术中的临床应用",
            text4: "查看详情",
          },
          {
            index: "zq5",
            imgUrl: "https://www.victrum.com/image/sprk/正畸儿牙/系带切除.png",
            text1: "铒激光在系带切除中的临床应用",
            text2: "2026年03月31日",
            text3: "铒激光在系带切除中的临床应用",
            text4: "查看详情",
          }
        ]
      }
    ]
  },
  {
    type: "en",
    videoUrl:"",
    videoUrl2:"https://www.victrum.com/image/nr/jjfa/11.mp4",
    numList : [
      {
        num : "1",
        tital : "Aesthetic Restoration",
        path: "mxxf"
      },
      {
        num : "2",
        tital : "Surgical Implantology",
        path: "ytys"
      },
      {
        num : "3",
        tital : "Operative Dentistry & Endodontics",
        path: "zz"
      },
      {
        num : "4",
        tital : "Periodontal Diseases",
        path: "zz"
      },
      {
        num : "5",
        tital : "Orthodontics & Pediatric Dentistry",
        path: "zz"
      },
    ],
    imgBoxUrl:"https://www.victrum.com/image/tp/临床应用banner.png",
    allData: [
      {
        num:"1",
        showdata:false,
        newDate: [
          {
            index: "mx1",
            imgUrl: "https://www.victrum.com/image/sprk/美学修复/拆除固定桥.png",
            text1: "Clinical Application of Erbium Laser in Removing Fixed Bridges",
            text2: "3/31/2026",
            text3: "Clinical Application of Erbium Laser in Removing Fixed Bridges",
            text4: "查看详情",
          },
          {
            index: "mx2",
            imgUrl: "https://www.victrum.com/image/sprk/美学修复/拆除牙冠.png",
            text1: "Clinical Application of Erbium Laser in Removing Dental Crowns",
            text2: "3/31/2026",
            text3: "Clinical Application of Erbium Laser in Removing Dental Crowns",
            text4: "查看详情",
          },
          {
            index: "mx3",
            imgUrl: "https://www.victrum.com/image/sprk/美学修复/牙龈脱色.png",
            text1: "Clinical Application of Erbium Laser in Gingival Depigmentation",
            text2: "3/31/2026",
            text3: "Clinical Application of Erbium Laser in Gingival Depigmentation",
            text4: "查看详情",
          },
          {
            index: "mx4",
            imgUrl: "https://www.victrum.com/image/sprk/美学修复/拆除瓷贴面.png",
            text1: "Clinical Application of Erbium Laser in Removing Porcelain Veneers",
            text2: "3/31/2026",
            text3: "Clinical Application of Erbium Laser in Removing Porcelain Veneers",
            text4: "查看详情",
          },
          {
            index: "mx5",
            imgUrl: "https://www.victrum.com/image/sprk/美学修复/激光取冠.png",
            text1: "Clinical Application of Erbium Laser in Crown Removal",
            text2: "3/31/2026",
            text3: "Clinical Application of Erbium Laser in Crown Removal",
            text4: "查看详情",
          }
        ]
      },
      {
        num:"2",
        showdata:false,
        newDate: [
          {
            index: "wk1",
            imgUrl: "https://www.victrum.com/image/sprk/外科种植/种植二期.png",
            text1: "Clinical Application of Erbium Laser in Second-Stage Implant Surgery",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Second-Stage Implant Surgery",
            text4: "查看详情",
          },
          {
            index: "wk2",
            imgUrl: "https://www.victrum.com/image/sprk/外科种植/种植体周围炎.png",
            text1: "Clinical Application of Erbium Laser in Peri-Implantitis",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Peri-Implantitis",
            text4: "查看详情",
          },
          {
            index: "wk3",
            imgUrl: "https://www.victrum.com/image/sprk/外科种植/种植二期手术-1.png",
            text1: "Clinical Application of Erbium Laser in Second-Stage Implant Surgery",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Second-Stage Implant Surgery",
            text4: "查看详情",
          },
          {
            index: "wk4",
            imgUrl: "https://www.victrum.com/image/sprk/外科种植/种植体二期手术.png",
            text1: "Clinical Application of Erbium Laser in Second-Stage Implant Surgery",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Second-Stage Implant Surgery",
            text4: "查看详情",
          },
          {
            index: "wk5",
            imgUrl: "https://www.victrum.com/image/sprk/外科种植/种植二期手术.png",
            text1: "Application of Erbium Laser in Second-Stage Implant Surgery",
            text2: "2026年03月31日",
            text3: "Application of Erbium Laser in Second-Stage Implant Surgery",
            text4: "查看详情",
          }
        ]
      },
      {
        num:"3",
        showdata:false,
        newDate: [
          {
            index: "yt1",
            imgUrl: "https://www.victrum.com/image/sprk/牙体牙髓/24窝沟龋.png",
            text1: "Clinical Application of Erbium Laser in Treatment of Occlusal Caries",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Treatment of Occlusal Caries",
            text4: "查看详情",
          },
          {
            index: "yt2",
            imgUrl: "https://www.victrum.com/image/sprk/牙体牙髓/根管荡洗.png",
            text1: "Clinical Application of Erbium Laser in Root Canal Irrigation",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Root Canal Irrigation",
            text4: "查看详情",
          },
          {
            index: "yt3",
            imgUrl: "https://www.victrum.com/image/sprk/牙体牙髓/活髓切断.png",
            text1: "Clinical Application of Erbium Laser in Pulpotomy",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Pulpotomy",
            text4: "查看详情",
          },
          {
            index: "yt4",
            imgUrl: "https://www.victrum.com/image/sprk/牙体牙髓/楔状缺损激光去腐.png",
            text1: "Application of Erbium Laser in Caries Removal for Wedge-Shaped Defects",
            text2: "2026年03月31日",
            text3: "Application of Erbium Laser in Caries Removal for Wedge-Shaped Defects",
            text4: "查看详情",
          },
          {
            index: "yt5",
            imgUrl: "https://www.victrum.com/image/sprk/牙体牙髓/牙本质脱敏.png",
            text1: "Clinical Application of Erbium Laser in Dentin Hypersensitivity",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Dentin Hypersensitivity",
            text4: "查看详情",
          }
        ]
      },
      {
        num:"4",
        showdata:false,
        newDate: [
          {
            index: "yz1",
            imgUrl: "https://www.victrum.com/image/sprk/牙周疾病/重度牙周炎.png",
            text1: "Clinical Application of Erbium Laser in Treatment of Severe Periodontitis",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Treatment of Severe Periodontitis",
            text4: "查看详情",
          },
          {
            index: "yz2",
            imgUrl: "https://www.victrum.com/image/sprk/牙周疾病/切除牙龈瘤.png",
            text1: "Clinical Application of Erbium Laser in Resection of Epulis",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Resection of Epulis",
            text4: "查看详情",
          },
          {
            index: "yz3",
            imgUrl: "https://www.victrum.com/image/sprk/牙周疾病/阿弗他溃疡.png",
            text1: "Clinical Application of Erbium Laser in Treatment of Aphthous Ulcers",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Treatment of Aphthous Ulcers",
            text4: "查看详情",
          },
          {
            index: "yz4",
            imgUrl: "https://www.victrum.com/image/sprk/牙周疾病/激光切龈.png",
            text1: "Clinical Application of Erbium Laser in Gingivectomy",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Gingivectomy",
            text4: "查看详情",
          },
          {
            index: "yz5",
            imgUrl: "https://www.victrum.com/image/sprk/牙周疾病/牙周袋清创.png",
            text1: "Clinical Application of Erbium Laser in Periodontal Pocket Debridement",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Periodontal Pocket Debridement",
            text4: "查看详情",
          }
        ]
      },
      {
        num:"5",
        showdata:false,
        newDate: [
          {
            index: "zq1",
            imgUrl: "https://www.victrum.com/image/sprk/正畸儿牙/导萌术.png",
            text1: "Clinical Application of Erbium Laser in Exposure of Impacted Teeth",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Exposure of Impacted Teeth",
            text4: "查看详情",
          },
          {
            index: "zq2",
            imgUrl: "https://www.victrum.com/image/sprk/正畸儿牙/龋齿治疗.png",
            text1: "Clinical Application of Erbium Laser in Treatment of Dental Caries",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Treatment of Dental Caries",
            text4: "查看详情",
          },
          {
            index: "zq3",
            imgUrl: "https://www.victrum.com/image/sprk/正畸儿牙/去龋.png",
            text1: "Clinical Application of Erbium Laser in Caries Removal",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Caries Removal",
            text4: "查看详情",
          },
          {
            index: "zq4",
            imgUrl: "https://www.victrum.com/image/sprk/正畸儿牙/激光助萌.png",
            text1: "Clinical Application of Erbium Laser in Assisting Eruption of Impacted Teeth",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Assisting Eruption of Impacted Teeth",
            text4: "查看详情",
          },
          {
            index: "zq5",
            imgUrl: "https://www.victrum.com/image/sprk/正畸儿牙/系带切除.png",
            text1: "Clinical Application of Erbium Laser in Frenectomy",
            text2: "2026年03月31日",
            text3: "Clinical Application of Erbium Laser in Frenectomy",
            text4: "查看详情",
          }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/clinicalNew.js